import { SADropdownOption } from '@missionlabs/smartagent-app-components/dist/Dropdown';

import { Agent } from 'components/Dropdowns/agents';
import { Queue } from 'components/Dropdowns/queues';

export enum ContactInitiationMethod {
    INBOUND = 'INBOUND',
    OUTBOUND = 'OUTBOUND',
    TRANSFER = 'TRANSFER',
    CALLBACK = 'CALLBACK',
    API = 'API',
    QUEUE_TRANSFER = 'QUEUE_TRANSFER',
}

// To do - manage all of the possible channels in Contact Search from this enum
export enum ContactChannel {
    ALL = 'ALL',
    VOICE = 'VOICE',
    TASK = 'TASK',
    CHAT = 'CHAT',
    EMAIL = 'EMAIL',
}

export enum ChannelColumnGroup {
    ALL = 'ALL',
    VOICE = 'VOICE',
    TASK = 'TASK',
    CHAT = 'CHAT',
    EMAIL = 'EMAIL',
    SOCIAL = 'SOCIAL',
}

export type ContactChannelDropdown = SADropdownOption<ContactChannel> & { group: ChannelColumnGroup };

export interface IContactSearchForm {
    contactID: string;
    agent?: Agent | undefined;
    queue?: Queue | undefined;
    initiationMethod?: SADropdownOption<ContactInitiationMethod | undefined>;
    phoneNumber: string;
    externalID: string;
    startDate: Date;
    startTime: string;
    endDate: Date;
    endTime: string;
    callDurationStartTime: string;
    callDurationEndTime: string;
    holdDurationStartTime: string;
    holdDurationEndTime: string;
    channel: ContactChannelDropdown;
    socialHandle: string;
    uniqueSocialId: string;
    chatEmail: string;
    chatOrderNumber: string;
    email: string;
    keyword?: string;
    emailSearchType: SADropdownOption<string>;
}

export interface IContactSearchOptions {
    initiation: SADropdownOption<string | undefined>[];
    channel: SADropdownOption<string | undefined>[];
    socialSearchType: SADropdownOption<string | undefined>[];
    chatSearchType: SADropdownOption<string | undefined>[];
    emailSearchType: SADropdownOption<string>[];
}

export enum SocialContactType {
    'Social Handle' = 'Social Handle',
    'Unique Social ID' = 'Unique Social ID',
}

export enum ChatContactType {
    'Email' = 'Email',
    'Order Number' = 'Order Number',
}

export enum EmailContactType {
    'All' = 'All',
    'To/From email address' = 'To/From email address',
    'Cc email address' = 'CC email address',
}

export enum ContactSearchActionTypes {
    SET_INTERACTIONS = 'SET_INTERACTIONS',
    LOADING_INTERACTIONS = 'LOADING_INTERACTIONS',
    SET_FORM_PARAMS = 'SET_FORM_PARAMS',
    RESET_FORM_PARAMS = 'RESET_FORM_PARAMS',
    SET_CONTACT_ID = 'SET_CONTACT_ID',
    SET_APP_CONTACT_ID = 'SET_APP_CONTACT_ID',
    SET_SELECTED_INTERACTION = 'SET_SELECTED_INTERACTION',
    SET_AGENT = 'SET_AGENT',
    SET_QUEUE = 'SET_QUEUE',
    SET_INITIATION_METHOD = 'SET_INITIATION_METHOD',
    SET_EXTERNAL_ID = 'SET_EXTERNAL_ID',
    SET_CUSTOMER_PHONE = 'SET_CUSTOMER_PHONE',
    SET_START_DATE = 'SET_START_DATE',
    SET_START_TIME = 'SET_START_TIME',
    SET_END_DATE = 'SET_END_DATE',
    SET_END_TIME = 'SET_END_TIME',
    SET_CALL_DURATION_START_TIME = 'SET_CALL_DURATION_START_TIME',
    SET_CALL_DURATION_END_TIME = 'SET_CALL_DURATION_END_TIME',
    SET_HOLD_DURATION_START_TIME = 'SET_HOLD_DURATION_START_TIME',
    SET_HOLD_DURATION_END_TIME = 'SET_HOLD_DURATION_END_TIME',
    SET_CHANNEL = 'SET_CHANNEL',
    SET_SOCIAL_HANDLE = 'SET_SOCIAL_HANDLE',
    SET_UNIQUE_SOCIAL_ID = 'SET_UNIQUE_SOCIAL_ID',
    SET_CHAT_EMAIL = 'SET_CHAT_EMAIL',
    SET_CHAT_ORDER_NUMBER = 'SET_CHAT_ORDER_NUMBER',
    SET_QUEUED_TASKS_AUDIT = 'SET_QUEUED_TASKS_AUDIT',
    SET_AUTOMATED_RULES_AUDIT = 'SET_AUTOMATED_RULES_AUDIT',
    ADD_TRANSFORMED_ATTACHMENTS = 'ADD_TRANSFORMED_ATTACHMENTS',
    SET_INTERACTION_ATTRIBUTES = 'SET_INTERACTION_ATTRIBUTES',
    SET_EMAIL = 'SET_EMAIL',
    SET_EMAIL_SEARCH_TYPE = 'SET_EMAIL_SEARCH_TYPE',
    SET_KEYWORD = 'SET_KEYWORD',
}

export interface togglePlaceholderTypes {
    startDate: string;
    endDate?: string;
    startTime?: string;
    endTime?: string;
    callDurationFrom?: string;
    callDurationTo?: string;
    holdDurationFrom?: string;
    holdDurationTo?: string;
}
